import { create } from 'zustand';

interface IExitRoomStore {
  isOpenModal: boolean;
  isOpenStopModal: boolean;
  onExitClick: () => void;
  onDismiss: () => void;
  setExitRoomState: (state: Partial<IExitRoomStore>) => void;
}

export const useExitRoomStore = create<IExitRoomStore>((set) => ({
  isOpenModal: false,
  isOpenStopModal: false,
  onDismiss: () => {},
  onExitClick: () => {},
  setExitRoomState(exitRoomState: Partial<IExitRoomStore>) {
    set((state) => ({
      ...state,
      ...exitRoomState,
    }));
  },
}));
